<div class="m-portlet portlet-batches-notranslate table table-overflow">
	<div class="m-portlet__head" *ngIf="label">
		<div class="m-portlet__head-caption">
			<div class="m-portlet__head-title">
				<h3 class="m-portlet__head-text m--font-info">
					{{label}}
				</h3>
			</div>
		</div>
		<div *ngIf="isBackButton" class="m-portlet__head-tools">
			<button (click)="location.back()" type="button"
				class="btn btn-secondary m-btn m-btn--custom m-btn--outline-2x button-round">
				Back
			</button>
		</div>
	</div>
	<div class="searchOptionsBox" *ngIf="table && table.mixedFilters && table.mixedFilters.length">
		<div class="container-fluid">
			<div class="row">
				<div class="col-lg-2" *ngFor="let filter of table.mixedFilters">
					<div [hidden]="filter.hide">
						<ng-container *ngIf="filter.type === FILTER_TYPES.SELECT">
							<label>{{filter.label}}</label>
							<select class="form-control m-input notranslate" name="selectStatus"
								(change)="onSelectFilterChangeData($event, filter.name)"
								[(ngModel)]="appliedFilter[filter.name]">
								<option value=undefined>{{filter.placeholder}}</option>
								<option [value]="filterOption.value || filterOption.label || filterOption"
									*ngFor="let filterOption of filter.options">
									{{filterOption.label || filterOption.value || filterOption}}</option>
							</select>
						</ng-container>
					</div>
					<ng-container *ngIf="filter.type === FILTER_TYPES.TEXT">
						<label>{{filter.label}}</label>
						<input type="text" [(ngModel)]="appliedFilter[filter.name]"
							class="form-control m-input m-input--solid notranslate" [placeholder]="filter.placeholder"
							[id]="filter.id">
					</ng-container>
					<ng-container *ngIf="filter.type === FILTER_TYPES.DATE">
						<label>{{filter.label}}</label>
						<input type="text" (blur)="appliedFilter[filter.name]=dp.value"
							[(ngModel)]="appliedFilter[filter.name]" class="form-control m-input m-input--solid notranslate"
							[placeholder]="filter.placeholder" [id]="filter.id" #dp>
					</ng-container>
					<!-- <label>{{filter.name}}</label>
					<select class="form-control m-input" name="selectStatus" [(ngModel)]="appliedFilter[filter.value || filter.name]">
						<option [value]="filterOption.value || filterOption.label || filterOption" *ngFor="let filterOption of filter.options">{{filterOption.label || filterOption.value || filterOption}}</option>
					</select> -->
				</div>
				<div class="col-lg-1 padding-top-20">
					<label></label>
					<button class="btn btn-primary margin-top-10" (click)="onApplyFilter()">Apply</button>
				</div>
				<div class="col-lg-1" *ngIf="isResetButton">
					<label></label>
					<button class="btn btn-secondary m-btn margin-top-20 padding" (click)="onResetFilter()"> Reset
					</button>
				</div>
			</div>
		</div>
	</div>
	<div class="searchOptionsBox" *ngIf="filters && filters.length">
		<div class="container-fluid">
			<div class="row">
				<div class="col-lg-2" *ngFor="let filter of filters">
					<label>{{filter.name}}</label>
					<select class="form-control m-input notranslate" name="selectStatus"
						[(ngModel)]="appliedFilter[filter.value || filter.name]">
						<option [value]="filterOption.value || filterOption.label || filterOption"
							*ngFor="let filterOption of filter.options">
							{{filterOption.label || filterOption.value || filterOption}}</option>
					</select>
				</div>
				<div class="col-lg-1 padding-top-20">
					<label></label>
					<button class="btn btn-primary margin-top-30" (click)="onApplyFilter()">Apply</button>
				</div>
				<div *ngIf="isResetButton" class="col-lg-1 padding-top-20">
					<label></label>
					<button class="btn btn-secondary margin-top-30" (click)="onResetFilter()">Reset</button>
				</div>
			</div>
		</div>
	</div>
	<div class="searchOptionsBox" *ngIf="searchFilters && searchFilters.length">
		<div class="container-fluid">
			<div class="row">
				<div class="col-lg-2" *ngFor="let searchFilter of searchFilters">
					<label for="batchStartDateRange">{{searchFilter.label}}</label>
					<div class="m-input-icon m-input-icon--left">
						<input type="text" [(ngModel)]="searchFilter.value" class="form-control m-input m-input--solid notranslate"
							(keyup)="onKeyPress($event, [searchFilter.value, searchFilter.onSearch])"
							(blur)="searchFilter.onSearch(searchFilter.value)" [placeholder]="searchFilter.placeholder"
							id="generalSearch">
						<span class="m-input-icon__icon m-input-icon__icon--left">
							<span>
								<i class="la la-search"></i>
							</span>
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
	<br>
	<div class="m-portlet__body body-padding" [ngClass]="{'padding-left-right-zero': onlyTable}">
		<div class="m_datatable m-datatable m-datatable--default" id="local_data">
			<div class="table-container">
			<table class="table table-striped">
				<thead class="m-datatable__head">
					<tr class="m-datatable__row" style="left: 0px;">
						<th *ngIf="!table.withoutSerialNumber"
							class="m-datatable__cell--center m-datatable__cell m-datatable__cell--check center-text">
							<span class="sno-tableTextAllign">
								S.NO.
							</span>
						</th>
						<th class="m-datatable__cell m-datatable__cell--sort center-text table-width"
							*ngFor="let col of colLabels">
							<span class="tableTextAllign">{{col}}</span>
						</th>
					</tr>
				</thead>
				<tbody class="m-datatable__body margin-table notranslate">
					<p *ngIf="(!tableData || !tableData.length) && noDataMessage">{{noDataMessage}}</p>
					<tr data-row="0" class="m-datatable__row min-height-50" style="left: 0px;"
						*ngFor="let row of tableData;let i= index">
						<td *ngIf="!table.withoutSerialNumber"
							class="m-datatable__cell--center m-datatable__cell m-datatable__cell--check center-text">
							<div class="sno-tableTextAllign">
								<!-- <label class="m-checkbox m-checkbox--solid m-checkbox--state-brand">
									<input type="checkbox">
									<span></span>
								</label> -->
								{{sno + i+1}}
							</div>
						</td>
						<td class="m-datatable__cell center-text" *ngFor="let col of row">
							<span class="display-content min-height-50" *ngIf="col.show">
								<ng-container *ngIf="isArray(col.value) && col.value.length">
									<span style="overflow: visible; width: 100px;">
										<div class="dropdown">
											<a href="#"
												class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill"
												data-toggle="dropdown">
												<i class="la la-ellipsis-h"></i>
											</a>
											<div class="dropdown-menu dropdown-menu-right menu-overflow">

												<a class="dropdown-item" data-toggle="modal" data-target="#view-details"
													*ngFor="let action of col.value"
													(click)="doAction(i,action.onSelect)">
													{{action.label}}
												</a>
											</div>
										</div>
									</span>
								</ng-container>
								<ng-container
									*ngIf="isArray(col.value) && !col.value.length && col.classes&& col.classes.length">
									<a class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill"
										(click)="doAction(i,col.onSelect)">
										<i [ngClass]="col.classes"></i>
									</a>
								</ng-container>
								<span *ngIf="!isArray(col.value)" (click)="doAction(i,col.onSelect)"
									[ngClass]="col.classes">{{col.value}}</span>
							</span>
						</td>
					</tr>
				</tbody>
			</table>
			</div>
			<app-pagination *ngIf="isPaginationOnfilterInside" [defaultRecordsPerPage]="table.pagination.limit"
				[count]="table.pagination.count" (pageNumber)="onPageNumberChange($event)"
				(recordsPerPage)="onRecordsPerPageChange($event)">
			</app-pagination>
		</div>
	</div>
</div>